import React, { useState } from 'react'

import IconDone from 'client/icons/Done'
import styles from './styles.module.css'
import cn from 'classnames'
import Dropdown from 'src/comps/Atom/Drowpdown'
import ArrowDown from 'client/icons/ArrowDown'
import { Button, Typography } from '@s4l/ds'

interface Option<T, Z> {
  key: T
  value: Z
}

interface ISelectProps<T, Z> {
  readonly label?: string
  readonly onChange: (value: Option<T, Z>) => void
  readonly options: Option<T, Z>[]
  readonly defaultValue?: Option<T, Z>
  readonly align?: 'start' | 'center' | 'end'
}

function Select<T, Z>({
  label,
  onChange,
  options,
  defaultValue,
  align = 'center',
}: ISelectProps<T, Z>) {
  const [isOpen, setIsOpen] = useState(false)

  const [currentOrder, setCurrentOrder] = useState(defaultValue ?? options[0])

  function handleSelectOrder(newOrder: Option<T, Z>) {
    setCurrentOrder(newOrder)
    onChange(newOrder)
    setIsOpen(false)
  }

  const trigger = (
    <Button
      data-testid="trigger"
      trailingIcon={<ArrowDown size={16} />}
      variant="outlined-rounded"
      size="small"
      hover={isOpen}
      active={isOpen}
    >
      {label && <span>{label} &nbsp;</span>}
      {currentOrder.value as React.ReactNode}
    </Button>
  )

  return (
    <Dropdown
      show={isOpen}
      onShowChange={setIsOpen}
      align={align}
      showClose={false}
      trigger={trigger}
      triggerAsChild
    >
      <ul className={styles.list}>
        {options.map(order => {
          const { key, value } = order
          const isCurrentOrder = key === currentOrder.key

          return (
            <li key={`${key}`}>
              <button
                type="button"
                className={cn(styles.option, {
                  [styles.selected]: isCurrentOrder,
                })}
                onClick={() => handleSelectOrder(order)}
                role="menuitem"
              >
                <Typography variant="body" size="l" bold={isCurrentOrder}>
                  {value as React.ReactNode}
                </Typography>
                <IconDone size={24} />
              </button>
            </li>
          )
        })}
      </ul>
    </Dropdown>
  )
}

export default Select
